import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { SiAuth0 } from 'react-icons/si';

import {Button, Divider, Popover, Typography} from 'antd';
import {UserApp} from '../../Context/AuthProvider/AuthProviderActions';
import { UserInfo } from '../UserInfo';

const { Text } = Typography;

export const Auth0LogoutButton: React.FunctionComponent = () => {
    const {
        logout, isLoading,
        isAuthenticated,  user
    } = useAuth0();

    const handleLogout = React.useCallback( () => {
        logout({ logoutParams: { returnTo: window.location.origin } }).then( _res => {
            sessionStorage.removeItem('auth0-login');
        });
    }, [logout]);

    console.log({
        isAuthenticated: isAuthenticated,
        user:user
    } );

    const BUTTON = React.useMemo(()=>{
        return (
            <Button
                type="primary"
                onClick={handleLogout}
                icon={<SiAuth0 style={{ marginTop:4, marginRight: '8px', fontSize: '20px' }} />}
                loading={isLoading}
                disabled={ !isAuthenticated }
                block
            >
                Cerrar Sesión
            </Button>
        );
    }, [handleLogout, isAuthenticated, isLoading]);

    const ELEMENT = React.useMemo(()=>{
        if(isAuthenticated && user){
            const userInfo: UserApp = {
                id: 0, ids:0,
                clave: (user.nickname) ? user.nickname : '',
                first_name: (user.given_name) ? user.given_name : '',
                last_name: (user.family_name) ? user.family_name : '',
                full_name: `${user.given_name} ${user.family_name}`,
                email: (user.email) ? user.email : '',
                mail_validado: true,
                rol: '',
                is_admin: false,
                imagen: (user.picture) ? user.picture : undefined,
            };

            const userElement = (
                <React.Fragment>
                    <p><Text>Usted ha iniciado sesión previamente <br/>utilizando el siguiente usuario: </Text></p>
                    <p style={{textAlign:'center'}}><UserInfo user={userInfo} /></p>
                    <p><Text>Si desea cambiar de usuario de click al botón</Text></p>
                </React.Fragment>
            );

            return (
                <Popover title="Usaurio autenticado" content={ userElement } >
                    { BUTTON }
                </Popover>
            );
        }

        return BUTTON;
    }, [BUTTON, isAuthenticated, user]);

    if (!isAuthenticated) return null;

    return (
        <React.Fragment>
            <Divider />
            { ELEMENT }
        </React.Fragment>
    );
};
